import { Component, input, output } from '@angular/core';

import { ExpertSelectionInputComponent } from '../../../../components/expert-selection-input';
import { OrganizationSelectionInputComponent } from '../../../../shared/components/organization-selection-input';
import { ExpertDTO } from '../../../../types/expert.types';
import { OrganizationDTO } from '../../../../types/organization.types';
import { CommissionInvoicePayeeType } from '../../../../types/commission-invoice.types';
import { COMMISSION_INVOICE_PAYEE_TYPE } from '../../../../shared/definitons';

@Component({
  standalone: true,
  imports: [ExpertSelectionInputComponent, OrganizationSelectionInputComponent],
  selector: 'lib-commission-invoice-payee-step',
  template: `
    <section class="grid grid-cols-1 gap-4 lg:grid-cols-3">
      <div class="lg:col-span-1">
        <h2 class="text-base font-semibold text-gray-900">Payee</h2>
        <p class="mt-1 text-sm text-gray-500">
          Choose whether the invoice is for an individual expert or an
          organization, then select the payee.
        </p>
      </div>

      <div class="flex flex-col gap-6 lg:col-span-2">
        <div>
          <label class="block text-sm font-semibold text-gray-700 mb-2">Payee Type</label>
          <div class="flex gap-4">
            <label class="inline-flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="payeeType"
                [value]="PAYEE_TYPE.ExpertIndividual"
                [checked]="payeeType() === PAYEE_TYPE.ExpertIndividual"
                [disabled]="locked()"
                (change)="payeeTypeChange.emit(PAYEE_TYPE.ExpertIndividual)"
                class="text-orange-600 focus:ring-orange-500"
              />
              <span class="text-sm text-gray-700">Expert (Individual)</span>
            </label>
            <label class="inline-flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="payeeType"
                [value]="PAYEE_TYPE.ExpertOrganization"
                [checked]="payeeType() === PAYEE_TYPE.ExpertOrganization"
                [disabled]="locked()"
                (change)="payeeTypeChange.emit(PAYEE_TYPE.ExpertOrganization)"
                class="text-orange-600 focus:ring-orange-500"
              />
              <span class="text-sm text-gray-700">Organization</span>
            </label>
            <label class="inline-flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="payeeType"
                [value]="PAYEE_TYPE.Company"
                [checked]="payeeType() === PAYEE_TYPE.Company"
                [disabled]="locked()"
                (change)="payeeTypeChange.emit(PAYEE_TYPE.Company)"
                class="text-orange-600 focus:ring-orange-500"
              />
              <span class="text-sm text-gray-700">Company (SNDBX International)</span>
            </label>
          </div>
        </div>

        @if (payeeType() === PAYEE_TYPE.ExpertIndividual) {
        <lib-expert-selection-input
          label="Select Payee Expert"
          placeholder="Search for expert..."
          [required]="true"
          [disabled]="locked()"
          [selectedExpert]="selectedExpert()"
          (expertSelected)="expertSelected.emit($event)"
          (expertCleared)="expertCleared.emit()"
        />
        } @else if (payeeType() === PAYEE_TYPE.ExpertOrganization) {
        <lib-organization-selection-input
          label="Select Payee Organization"
          placeholder="Search for organization..."
          [required]="true"
          [disabled]="locked()"
          [selectedOrganization]="selectedOrg()"
          (organizationSelected)="orgSelected.emit($event)"
          (organizationCleared)="orgCleared.emit()"
        />
        } @else {
        <div>
          <label class="block text-sm font-semibold text-gray-700 mb-1">Payee</label>
          <div class="inline-flex items-center rounded-md bg-orange-50 px-3 py-2 text-sm font-medium text-orange-800 border border-orange-200">
            SNDBX International
          </div>
        </div>
        }
      </div>
    </section>
  `,
})
export class CommissionInvoicePayeeStepComponent {
  protected readonly PAYEE_TYPE = COMMISSION_INVOICE_PAYEE_TYPE;

  payeeType = input.required<CommissionInvoicePayeeType>();
  selectedExpert = input<ExpertDTO | null>(null);
  selectedOrg = input<OrganizationDTO | null>(null);
  locked = input<boolean>(false);

  payeeTypeChange = output<CommissionInvoicePayeeType>();
  expertSelected = output<ExpertDTO>();
  expertCleared = output<void>();
  orgSelected = output<OrganizationDTO>();
  orgCleared = output<void>();
}
